import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLargeLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M15.278 2.48829L9.62257 11.9997L15.278 21.511L13.9887 22.2776L7.87744 11.9997L13.9887 1.72168L15.278 2.48829Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeLeft;
